<template>
  <div
    class="accounts-collection-detail-collection"
    v-if="registerMsg"
  >
    <bill-container :title="$t('fms_accounts_collection_detail_collection.zhang_dan_lie_biao')">
      <accounts-registration-accounts-bill
        v-model="billList"
        ref="payableBill"
        :auth="[]"
        :paymentOrReceivable="paymentOrReceivable"
      ></accounts-registration-accounts-bill>
    </bill-container>
    <bill-container :title="$t('fms_accounts_collection_detail_collection.zhi_fu_xin_xi')" v-if="billList.length">
      <accounts-registration-msg-bill
        v-model="tradeList"
        ref="msgBill"
        :billInfo="registerMsg"
        :outerItem="firstOrderItem"
        :auth="[]"
        :paymentOrReceivable="paymentOrReceivable"
        :expandFlowMsg="true"
      ></accounts-registration-msg-bill>
    </bill-container>
  </div>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import billContainer from './bill_container';
import accountsRegistrationAccountsBill from './accounts_registration_accounts_bill';
import accountsRegistrationMsgBill from './accounts_registration_msg_bill';
import mixins from './mixins';

export default {
  name: '',
  mixins: [dialogMixins, mixins],
  components: {
    billContainer,
    accountsRegistrationAccountsBill,
    accountsRegistrationMsgBill,
  },
  props: {
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false
    },
    registerMsg: Object,
    billList: Array,
    tradeList: Array,
  },
  data() {
    return {
      firstOrderItem: {},
    };
  },
  computed: {
  },
  watch: {
    billList: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.firstOrderItem = val[0];
        }
      }
    }
  },
  filters: {
  },
  directives: {
  },
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.accounts-collection-detail-collection {
  padding-top: 16px;
}
</style>
